<script lang="ts">
    import {Flex, Spacer} from 'shared/layouts';
    import {LabeledValue} from 'src/features/erp-sutor/shared';
    import {ReportDetail} from 'src/features/erp-sutor/features/report-detail';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {getIdFromGridFieldValue, getTextFromGridFieldValue} from '../../../../sutor-utils';
    import {getProjectReportOptimisationContext} from '../../project-report-optimisation-context';
    import {getFirstFieldByFieldTypeIdRecursive} from 'src/features/record-grid/lib/grid-fields';
    import {exists} from 'shared/utils/custom-utils';
    import {FOND_REPORT} from '../../../../sutor-fonds';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpChipTag from 'shared/ui-widgets/chip/KpChipTag.svelte';

    export let reportRecord: RecordRow;
    export let optimisedBusinessItemRecord: RecordRow;

    const context = getProjectReportOptimisationContext();

    const stateField = getFirstFieldByFieldTypeIdRecursive(reportRecord, FOND_REPORT.stateFieldId);
    let saving = false;

    const handleUseForOptimisation = async () => {
        saving = true;
        const success = await context.service.useForOptimisation(context.projectRecord, optimisedBusinessItemRecord, reportRecord);

        if (exists(success)) {
            context.addUsedReportForOptimisation(reportRecord.id);
        }

        saving = false;
    };
</script>

<ReportDetail record={reportRecord}
              options={{editableTextNote: false, showAttendance: false, showSameDayReportHoursSum: false}}>

    <svelte:fragment slot="header">
        <Flex class="state-buttons-container" alignItems="center" gap="s">
            <KpButton buttonStyle="success" isDisabled={saving} on:click={handleUseForOptimisation}>
                <IconedContent icon="check-circle">Použít k optimalizaci</IconedContent>
            </KpButton>

            <Spacer flex="1"/>

            <LabeledValue label="Stav schválení" alignToEnd>
                <KpChipTag chipSize="sm"
                           chipStyle={FOND_REPORT.STATE_CHIP_STYLES[getIdFromGridFieldValue(stateField)] ?? 'default'}>

                    {getTextFromGridFieldValue(stateField)}
                </KpChipTag>
            </LabeledValue>
        </Flex>
    </svelte:fragment>
</ReportDetail>